module.exports = __webpack_public_path__ + "img/step2-1-1.4b863132.png";